/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Control_Tools_Planner_TitleInputs */

const en_control_tools_planner_title = /** @type {(inputs: Control_Tools_Planner_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build Planner`)
};

const zh_control_tools_planner_title = /** @type {(inputs: Control_Tools_Planner_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`配装规划器`)
};

/**
* | output |
* | --- |
* | "Build Planner" |
*
* @param {Control_Tools_Planner_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const control_tools_planner_title = /** @type {((inputs?: Control_Tools_Planner_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Control_Tools_Planner_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_control_tools_planner_title(inputs)
	return zh_control_tools_planner_title(inputs)
});
export { control_tools_planner_title as "control.tools.planner.title" }